import React, { useState } from "react";
import {
  DialogContent,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { createSchoolUser } from "../../../config/firebase";
import SchoolsDropdownById from "../inc/SchoolsDropdownById";
import useData from "../hooks/useSchoolDropdown";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import ModalActions from "../../common/ModalActions";

const AddForm = ({ onSuccess, onClose }) => {
  const [name, setName] = useState("");
  const [school, setSchool] = useState(null);
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState("");
  const [techPrepInstructorFlag, setTechPrepInstructorFlag] = useState(false);
  const [techPrepCoordFlag, setTechPrepCoordFlag] = useState(false);
  const [ccpSchoolFlag, setCcpSchoolFlag] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // State variable for loading

  const { data: schools, loading: schoolsLoading } = useData();

  // Function to format phone number with dashes as the user types
  const formatPhoneNumber = (input) => {
    // Remove non-numeric characters
    const cleaned = ("" + input).replace(/\D/g, "");

    // Apply phone number formatting
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return input;
  };

  const handlePhoneChange = (e) => {
    // Format phone number as the user types
    const formattedPhone = formatPhoneNumber(e.target.value);
    setPhone(formattedPhone);
  };

  const handleAddUser = async () => {
    setLoading(true); // Set loading to true when the user is being added
    const schoolName = school ? school.school_name : "";
    const schoolId = school ? school.school_id : "";

    const { success, message } = await createSchoolUser(
      name,
      schoolName,
      email,
      title,
      password,
      phone,
      ccpSchoolFlag,
      techPrepInstructorFlag,
      techPrepCoordFlag,
      userType,
      schoolId
    );

    if (success) {
      onSuccess(); // Callback function to handle success in parent component
    } else {
      console.error(message);
    }
    setLoading(false); // Set loading to false after the user is added
  };

  return (
    <>
      <ModalDialogTitle onClose={onClose}>Add New User</ModalDialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress />
            <Box mt={2}>Adding user...</Box>
          </Box>
        ) : (
          <>
            <TextField
              autoFocus
              margin="dense"
              label="Name"
              type="text"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {schoolsLoading ? (
              <CircularProgress />
            ) : (
              <SchoolsDropdownById
                schools={schools}
                value={school}
                onChange={setSchool}
              />
            )}
            <TextField
              margin="dense"
              label="Email"
              type="email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Title"
              type="text"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Phone"
              type="text"
              fullWidth
              value={phone}
              onChange={handlePhoneChange}
            />

            <FormControl fullWidth margin="dense">
              <InputLabel>User Type</InputLabel>
              <Select
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
                label="User Type"
              >
                <MenuItem value="RCPA">RCPA</MenuItem>
                <MenuItem value="GPA">GPA</MenuItem>
                <MenuItem value="DPA">DPA</MenuItem>
                <MenuItem value="tpcoordinator">Tech Prep Coordinator</MenuItem>
                <MenuItem value="tpinstructor">Tech Prep Instructor</MenuItem>
              </Select>
            </FormControl>
            <TextField
              margin="dense"
              label="Password"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={ccpSchoolFlag}
                  onChange={(e) => setCcpSchoolFlag(e.target.checked)}
                />
              }
              label="CCP School User"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={techPrepCoordFlag}
                  onChange={(e) => setTechPrepCoordFlag(e.target.checked)}
                />
              }
              label="Tech Prep Coordinator"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={techPrepInstructorFlag}
                  onChange={(e) => setTechPrepInstructorFlag(e.target.checked)}
                />
              }
              label="Tech Prep Instructor"
            />
          </>
        )}
      </DialogContent>
      <ModalActions onSave={handleAddUser} saveLabel="Add User" />
    </>
  );
};

export default AddForm;
